import React, { useState } from 'react'

import { Box } from '../Box'
import { TextButton } from '../Button'
import { Text } from '../Text'

interface BioProps {
  bio: string
}

export const Bio = ({ bio }: BioProps) => {
  const [shouldShowFullBio, setShouldShowFullBio] = useState(false)

  return (
    <>
      <Text
        fontSize='sm'
        color='v2black'
        ellipsizeMode={!shouldShowFullBio ? 'tail' : undefined}
        numberOfLines={!shouldShowFullBio ? 2 : undefined}
        withLinks
      >
        {bio}
      </Text>
      {bio.length > 108 || (bio.match(/\n/g) || []).length > 2 ? (
        <Box align='flex-end'>
          <TextButton
            onPress={() => setShouldShowFullBio(!shouldShowFullBio)}
            size='sm'
            bold={false}
            underline={false}
            title={`${shouldShowFullBio ? 'less' : 'more'}`}
            type='greyDark'
          />
        </Box>
      ) : null}
    </>
  )
}
